import { useEffect } from 'react';

import { logger, LogType } from 'core/atoms/housekeeping';

import { Grid } from 'core/cells/grid';

import { StudentsTable } from './components/students-table';

export const StudentListMainContent = () => {
  useEffect(() => {
    logger.debug({
      title: 'did mount',
      type: LogType.Info,
      logger: 'student-list-main-content',
    });
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <StudentsTable />
      </Grid>
    </Grid>
  );
};
